import mijnkeuzeStore from '../../../../../templates/sections/mijnKeuze/store/store';
import { logAnalyticsEvent } from '../../../../../assets/js/helpers/bananas';

export default {
    props: {
        location: Object,
        filters: Object,
        products: Array,
    },
    data() {
        return {
            savedComparison: null,
            receiver: 'self',
            step: 1,
            comparison: {
                email_address: mijnkeuzeStore.getters.account && mijnkeuzeStore.getters.account.email_address ? mijnkeuzeStore.getters.account.email_address : '',
                remarks: null,
                message: null,
                compare_url: window.location.href,
                product_count: this.products.length,
                location_object: this.location,
                filters: this.filters,
                products: null,
                subscribe_mail_campaigns: false,
                friend_id: null,
            },
        };
    },
    mounted() {
        this.$refs.saveComparisonModal?.$refs.input.addEventListener('change', (change) => {
            this.logEvent(change.target.checked ? 'openModal' : 'closeModal');
        });
    },
    computed: {
        signedIn() {
            return !!mijnkeuzeStore.getters.account.email_address && mijnkeuzeStore.getters.tokenValid;
        },
        canSaveComparison() {
            return this.products.length > 0 && !!this.comparison.location_object;
        },
        modalType() {
            return this.step === 1 ? 'PickReceiverModal' : 'SaveComparisonModal';
        },
        confirmEmailAddress() {
            return this.comparison.email_address ?? 'je e-mailadres';
        },

    },
    methods: {
        comparisonSaved(comparison) {
            this.savedComparison = comparison;
        },
        nextStep() {
            if (this.receiver === 'self') {
                this.comparison.friend_id = null;
            } else if (this.receiver === 'friend') {
                this.comparison.email_address = null;
            } else if (this.receiver === 'other' || this.receiver === 'mail-self') {
                this.comparison.friend_id = null;
            }
            this.logEvent('nextStep', {
                receiver: this.receiver,
                signedIn: this.signedIn,
            });
            this.step = 2;
        },
        logEvent(event, eventData) {
            logAnalyticsEvent(`saveComparison.${event}`, eventData);
        },
        previousStep() {
            this.step = 1;
        },
        updateComparison() {
            this.previousStep();
            this.savedComparison = null;
            this.comparison.location_object = this.location;
            this.comparison.products = this.products;
            this.comparison.product_count = this.products.length;
            this.comparison.filters = this.filters;
            this.comparison.compare_url = window.location.href;
        },
    },
    watch: {
        savedComparison: {
            handler() {
                this.$emit('savedComparison', this.savedComparison);
            },
        },
        location: {
            handler() {
                this.updateComparison();
            },
            deep: true,
        },
        products: {
            handler() {
                this.updateComparison();
            },
            deep: true,
        },
    },

};
